export default __webpack_public_path__ + "static/media/newsletter8.47338520.jpeg";